import { Controller } from "@hotwired/stimulus"
import { SearchButton } from "@coreui/coreui-pro"

// Pagila e09e99e introduces SearchButton; keep Cybros' existing report index.
export default class extends Controller {
  connect() {
    this.searchButton = SearchButton.getOrCreateInstance(this.element)
    this.dialog = document.getElementById("report-search-dialog")
    this.palette = this.dialog?.querySelector("ninja-keys")
    this.cancel = event => {
      event.preventDefault()
      this.close()
    }
    this.dialog?.addEventListener("cancel", this.cancel)
  }

  async open() {
    const palette = this.palette
    if (!palette || !this.dialog) return
    await palette.updateComplete
    if (!this.element.isConnected || !this.searchButton) return

    if (palette.visible) {
      this.close()
      return
    }

    this.dialog.showModal()
    palette.dispatchEvent(new CustomEvent("report-search:open"))
    palette.open()
    // Ninja renders in a shadow root and closes itself on selection, Escape
    // and backdrop clicks. Keep the native modal's lifetime in sync.
    this.observer?.disconnect()
    const modal = palette.shadowRoot?.querySelector(".modal")
    this.observer = new MutationObserver(() => {
      if (!palette.visible) this.close()
    })
    if (modal) this.observer.observe(modal, { attributes: true, attributeFilter: ["class"] })
  }

  close() {
    this.observer?.disconnect()
    this.palette?.close()
    this.dialog?.close()
    if (this.element.isConnected) this.element.focus()
  }

  unmount() {
    this.observer?.disconnect()
    this.palette?.close()
    this.dialog?.close()
    this.dialog?.removeEventListener("cancel", this.cancel)
    this.searchButton?.dispose()
    this.searchButton = null
  }

  disconnect() {
    this.unmount()
  }
}
